import { z } from "zod";
import { NativeInvoiceAdjustmentKind } from "@common/constants/nativeInvoice";

const MAX_ADJUSTMENT_CLASSES = 100;

const buildPerKindShape = <T extends z.ZodTypeAny>(
    schema: T,
): Record<NativeInvoiceAdjustmentKind, T> => ({
    tax: schema,
    discount: schema,
    deposit: schema,
});

export const nativeInvoiceAdjustmentSettingInputSchema = z
    .object({
        classIds: z
            .array(z.string().uuid())
            .max(MAX_ADJUSTMENT_CLASSES)
            .refine((ids) => new Set(ids).size === ids.length, {
                message: "Class IDs must be unique",
            }),
        accountId: z.string().uuid().nullable(),
        receivablesAccountId: z.string().uuid().nullable(),
    })
    .partial()
    .strict();

export const nativeInvoiceAdjustmentSettingsInputSchema = z
    .object(
        buildPerKindShape(
            nativeInvoiceAdjustmentSettingInputSchema.nullable().optional(),
        ),
    )
    .strict();

export const nativeInvoiceAdjustmentSettingResponseSchema = z.object({
    classIds: z.array(z.string().uuid()),
    accountId: z.string().uuid().nullable(),
    receivablesAccountId: z.string().uuid().nullable(),
});

export const nativeInvoiceAdjustmentSettingsResponseSchema = z.object(
    buildPerKindShape(nativeInvoiceAdjustmentSettingResponseSchema.nullable()),
);

export type NativeInvoiceAdjustmentSettingInput = z.infer<
    typeof nativeInvoiceAdjustmentSettingInputSchema
>;
export type NativeInvoiceAdjustmentSettingsInput = z.infer<
    typeof nativeInvoiceAdjustmentSettingsInputSchema
>;
export type NativeInvoiceAdjustmentSetting = z.infer<
    typeof nativeInvoiceAdjustmentSettingResponseSchema
>;
export type NativeInvoiceAdjustmentSettings = z.infer<
    typeof nativeInvoiceAdjustmentSettingsResponseSchema
>;
